import { Button, Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  formulaFilterOptions,
  formulaTableDesktopHeaders,
} from "../../helpers/formulaConstants";
import useMultiNotification from "../../hooks/useNotification";
import AddNewFormulaModal from "../../modals/AddNewFormulaModal";
import UpdateFormulaDetailsModal from "../../modals/UpdateFormulaDetailsModal";
import {
  deleteFormulaApi,
  getAllFormulasApi,
  updateFormulaStatusApi,
} from "../../redux-toolkit/slices/formulasSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import AppSelectFilter from "../Items/AppSelectFilter";
import FormulaItemCard from "../Items/cards/FormulaItemCard";
import SearchComponent from "../Items/Search";
import TableHeader from "../Items/Table/Header";
import LeftCol from "../wrappers/NewEntryFormLeftColWrapper";
import RightCol from "../wrappers/NewEntryFormRightColWrapper";
import FormulaTableRow from "./FormulasTableRow";
import AppLoader from "../Items/loader/AppLoader";

export default function ViewFormulasComponent() {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();

  const generalState = useSelector((state: RootState) => state.general);
  const { formulasData, isFormulasApiLoading } = useSelector(
    (state: RootState) => state.formulas
  );
  const [activePage, setActivePage] = useState<number>(1);
  const [searchedTerm, setSearchedTerm] = useState("");
  const { isShowTableInDesktop } = generalState;
  const [desktopTableHeaders, setDesktopTableHeaders] = useState<
    DesktopTableHeaderOption[]
  >(formulaTableDesktopHeaders);
  const handleOnSearch = (search: string) => {
    setSearchedTerm(search);
    dispatch(
      getAllFormulasApi({
        page: activePage,
        searchTerm: search,
        formulaStatus: selectedValue,
      })
    );
  };
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [formula, setFormula] = useState<IFormula | null>(null);
  const [selectedValue, setSelectedValue] = useState<string>("");

  const handleSelectChange = (value: string) => {
    setSelectedValue(value);
    dispatch(
      getAllFormulasApi({
        page: activePage,
        searchTerm: searchedTerm,
        formulaStatus: value,
      })
    );
  };
  const handleCheckBox = (checked: boolean, id: string) => {};
  useEffect(() => {
    dispatch(
      getAllFormulasApi({
        page: activePage,
        searchTerm: searchedTerm,
        formulaStatus: selectedValue,
      })
    );
  }, []);
  const handleClose = (isReload: boolean) => {
    if (isReload) {
      dispatch(
        getAllFormulasApi({
          page: activePage,
          searchTerm: searchedTerm,
          formulaStatus: selectedValue,
        })
      );
    }
    setShow(false);
    setShowEdit(false);
    setFormula(null);
  };
  const handleUpdateFormulaStatus = async (_id: string, isActive: boolean) => {
    try {
      const values: IUpdateFormulaStatusApi = {
        _id,
        isActive,
      };
      const res = await dispatch(updateFormulaStatusApi(values)).unwrap();
      openNotification(`success`, `Success`, res.message);
      dispatch(
        getAllFormulasApi({
          page: activePage,
          searchTerm: searchedTerm,
          formulaStatus: selectedValue,
        })
      );
    } catch (error) {
      if (typeof error === "string") {
        openNotification(`error`, `Error`, error);
      } else {
        openNotification(`error`, `Error`, `Server Error`);
      }
    }
  };
  const deleteFormula = async (data: IDeleteFormulaApi) => {
    try {
      const res = await dispatch(deleteFormulaApi(data)).unwrap();
      openNotification(`success`, `Success`, res.message);
      dispatch(
        getAllFormulasApi({
          page: activePage,
          searchTerm: searchedTerm,
          formulaStatus: selectedValue,
        })
      );
    } catch (error) {
      if (typeof error === "string") {
        openNotification(`error`, `Error`, error);
      } else {
        openNotification(`error`, `Error`, `Server Error`);
      }
    }
  };
  const handleEditFormula = (activeFormula: IFormula) => {
    setFormula(activeFormula);
    setShowEdit(true);
  };
  if (isFormulasApiLoading) {
    return <AppLoader />;
  }
  return (
    <>
      {contextHolder}
      {show === true && (
        <AddNewFormulaModal show={show} handleClose={handleClose} />
      )}
      {showEdit === true && formula !== null && (
        <UpdateFormulaDetailsModal
          show={showEdit}
          formula={formula}
          handleClose={handleClose}
        />
      )}
      <Card>
        <Row gutter={[16, 16]}>
          <LeftCol>
            <Typography className="dashboard-page-title">Formulas</Typography>
          </LeftCol>
          <RightCol>
            <div className="dashboard-search-container">
              <SearchComponent width="50%" onSearch={handleOnSearch} />
            </div>
          </RightCol>
        </Row>
        <Row className="mt-10 mb-10" gutter={[16, 16]}>
          <Col span={24}>
            <Typography className="dashboard-page-sub-title">
              Filters
            </Typography>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col md={6} lg={6} sm={12} xs={12}>
            <AppSelectFilter
              label={formulaFilterOptions.STATUS.LABEL}
              options={formulaFilterOptions.STATUS.options}
              onChange={handleSelectChange}
              placeHolder={formulaFilterOptions.STATUS.placeHolder}
            />
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px",
              marginTop: "10px",
            }}
            span={24}
          >
            <Button
              onClick={(e) => {
                setShow(true);
              }}
              type="primary"
            >
              Add New
            </Button>
          </Col>
        </Row>
        {isShowTableInDesktop === true ? (
          <>
            <Row className="table-container">
              <TableHeader
                headOptions={desktopTableHeaders}
                handleCheckBox={handleCheckBox}
              />
              {formulasData.map((formula, index) => {
                return (
                  <FormulaTableRow
                    key={`formula-desktop-single-row-${index}`}
                    activeBg={index % 2 === 0 ? "#F9F9F9" : "#FFFFFF"}
                    formula={formula}
                    handleUpdateFormulaStatus={handleUpdateFormulaStatus}
                    deleteFormula={deleteFormula}
                    handleEditFormula={handleEditFormula}
                  />
                );
              })}
              {/* <FormulaTableRow activeBg="" /> */}
            </Row>
          </>
        ) : (
          <>
            <Row gutter={[16, 16]}>
              {formulasData.map((formula, index) => {
                return (
                  <Col
                    key={`formula-desktop-single-row-${index}`}
                    lg={12}
                    md={12}
                    xl={12}
                    xxl={12}
                    sm={24}
                    xs={24}
                  >
                    <FormulaItemCard
                      handleEditFormula={handleEditFormula}
                      formula={formula}
                      key={`formula-desktop-single-row-card-${index}`}
                      handleUpdateFormulaStatus={handleUpdateFormulaStatus}
                      deleteFormula={deleteFormula}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        )}
      </Card>
    </>
  );
}
